import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import PartnerSection from '../../components/PartnerSection/PartnerSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.png'
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import SEO from '../../components/Seo';


const ServicePage = () => {
    return (
        <Fragment>
            <SEO
                title="Real Estate Services | Buy, Sell & Rent Property - LuxRock Realty"
                description="LuxRock Realty offers property buying, selling, rental and investment consulting services. Trusted real estate experts helping you make safe property decisions."
                keywords="real estate services, property consultant surat, buy sell property, property investment consulting, LuxRock Realty services"
            />


            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={'What’s part of the service'} pagesub={'Services'} />
            <ScrollTextAnimation />
            <ServiceSection hclass={'wpo-service-section'} />
            <PartnerSection hclass={'wpo-partners-section fade_bottom'} />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ServicePage;



